import { JSONContent } from '@tiptap/react';

/**
 * Recorre recursivamente el árbol JSON de TipTap para extraer el texto plano.
 */
export function extractTextFromTiptap(node: any): string {
  if (!node) return '';
  if (node.type === 'text' && typeof node.text === 'string') {
    return node.text;
  }
  if (Array.isArray(node.content)) {
    return node.content.map(extractTextFromTiptap).join(' ');
  }
  return '';
}

/**
 * Calcula el tiempo de lectura estimado (200 palabras por minuto).
 * Retorna al menos 1 minuto.
 */
export function calculateReadingTime(content: JSONContent): number {
  const text = extractTextFromTiptap(content);
  const words = text.trim().split(/\s+/).filter(w => w.length > 0).length;
  const minutes = Math.ceil(words / 200);
  return minutes > 0 ? minutes : 1;
}

/**
 * Genera un resumen (resumen) de hasta 150 caracteres basándose en el contenido de TipTap.
 */
export function generateSummary(content: JSONContent): string {
  const text = extractTextFromTiptap(content).trim();
  if (text.length <= 150) return text;
  return text.substring(0, 147) + '...';
}

/**
 * Convierte texto plano devuelto por el traductor a formato JSONContent de Tiptap.
 */
export function convertTextToTiptap(text: string): JSONContent {
  return {
    type: 'doc',
    content: [
      {
        type: 'paragraph',
        content: text ? [{ type: 'text', text }] : [],
      },
    ],
  };
}
